import {useMutation} from "react-query";
import {ResidentService} from "../../../services/ResidentServices";
import Alert from "react-s-alert";

export const useHideResident = ({refetch}: {refetch: () => void}) =>
  useMutation(
    (resident_id: string) =>
      ResidentService.patchResident(resident_id, {is_archived: true}),
    {
      onError: () => {
        Alert.error("Failed to hide resident.");
      },
      onSuccess: () => {
        refetch();
      },
    },
  );
